
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, Bond } from 'cw-backend';
import { SnackBarService } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class AccountsReceivableEditProvider implements Resolve<any> {
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    bond: Bond;
    path = "accounts-receivable/";

    constructor(public gw: ApiGateway, public snackBar: SnackBarService) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getBond()]).then(() => {
                resolve(true);
            }, reject);
        });
    }

    getBond(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data = this.checkLastModifications();

            if (data && data.id == this.routeParams.id) {
                this.bond = data;
                this.onDataChanged.next(this.bond);
                resolve(this.bond);
            } else if (this.routeParams.id === "novo") {
                this.onDataChanged.next(false);
                resolve(false);
            } else {
                this.gw.get(this.path + this.routeParams.id).subscribe({
                    next: (res: Bond) => {
                        this.bond = res;
                        this.onDataChanged.next(this.bond);
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
            }
        });
    }

    insert(bond): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(this.path, bond).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    if (!bond?.bondPay) {
                        this.snackBar.successMessage("Título cadastrado com sucesso.");
                    } else {
                        this.snackBar.successMessage("Título incluído e recebido.");
                    }
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    insertOfx(bond): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`${this.path}/ofx`, bond).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    insertBondPay(bondPay): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`${this.path}bond-pay`, bondPay).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    edit(bond): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`${this.path}`, bond).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage("Título atualizado com sucesso.");
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    delete(bond): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete(this.path + bond.id).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage("Título excluído com sucesso.");
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    deleteBondPayId(bondPayId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete(`${this.path}bond-pay/${bondPayId}`).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    checkLastModifications(): Bond {
        let wasLocked = JSON.parse(localStorage.getItem("session_locked"));
        let data;
        if (wasLocked) {
            data = JSON.parse(localStorage.getItem("last_modification"));
            localStorage.removeItem("session_locked");
        }
        return data;
    }
}
